import { Component, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { UtilService } from "../../../shared/services/util.service";
import { abastecimentoBensModuleName } from "../shared/data.service";
import { frotasQueryComCombustivel } from "../../../bens/frotas/shared/data.service";
import { Frota } from "../../../bens/frotas/shared/frota.model";
import { FrotasService } from "../../../bens/frotas/shared/frota.service";
import { FrotaApiService } from "../../../bens/frotas/shared/frota-api.service";
import { Area } from "../../../estruturas/areas/shared/area.model";
import { Combustivel } from "../../combustiveis/shared/combustivel.model";
import { AbastecimentoBemService } from "../shared/abastecimento-bem.service";
import { AbastecimentoBemApiService } from "../shared/abastecimento-bem-api.service";
import { areasQuery } from "../../../estruturas/areas/shared/data.service";
import { CombustivelApiService } from "../../combustiveis/shared/combustivel-api.service";
import { AreaApiService } from "../../../estruturas/areas/shared/area-api.service";
import { MotoristaApiService } from "../../../recursos-humanos/motoristas/shared/motorista-api.service";
import { Motorista } from "../../../recursos-humanos/motoristas/shared/motorista.model";
import { MotoristaService } from "../../../recursos-humanos/motoristas/shared/motorista.service";
import { isNumeric } from "rxjs/util/isNumeric";
import { Local, LocalCombustivel } from "../../locais/shared/local.model";
import { LocalApiService } from "../../locais/shared/local-api.service";
import { LocalService } from "../../locais/shared/local.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { AbastecimentoBemNavigationService } from "../shared/abastecimento-bem-navigation.service";
import { AbastecimentoBem } from "../shared/abastecimento-bem.model";
import { BemCombustivelApiService } from "../../../bens/bem-combustiveis/bem-combustivel-api.service";
import { motoristasQuery } from "../../../recursos-humanos/motoristas/shared/data.service";
import { NumberValidator } from "../../../shared/validators/number.validation";
import { TanqueApiService } from "../../tanques/shared/tanque-api.service";
import { BombaApiService } from "../../bombas/shared/bomba-api.service";
import { Bomba } from "../../bombas/shared/bomba.model";
import { Tanque } from "../../tanques/shared/tanque.model";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import {FormaControleService} from "../../../bens/formas-controle/shared/forma-controle.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";

@Component({
    template: require('./abastecimento-bem-form.component.html'),
    styles: [require('./abastecimento-bem-form.component.css')]
})
export class AbastecimentoBemFormComponent implements OnInit, AfterViewChecked {
    abastecimentoBensModule: any = abastecimentoBensModuleName;
    formObject: any = new AbastecimentoBem();
    frotaObject: any = new Frota();
    motoristaObject: any = new Motorista();
    areaObject: any = new Area();
    combustivelObject: any = new Combustivel();
    odometroHorimetroObject: any = {};
    localObject: any = new Local();
    bombaObject: any = new Bomba();
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    actionTitle: string;
    tipoAbastecimentoExterno: number;
    tipoAbastecimentoInterno: number;
    tipoAbastecimentoConvenio: number;
    loadingSpinnerCombustiveis: boolean = false;
    loadingSpinnerLocais: boolean = false;
    loadingSpinnerBombas: boolean = false;
    combustivelTextValue: string;
    combustiveisBemText: string;
    frotaCombustiveis: any[];

    showFrotaLink: boolean = false;
    frotaDetailHistory: any = {};
    frotaRoute: string;
    frotasModule: any = {};

    frotaQuery: any = {};
    frotaSelectId: string = 'frotaSelect';
    motoristaQuery: any = {};
    motoristaSelectId: string = 'motoristaSelect';
    areaQuery: any = {};
    areaSelectId: string = 'areaSelect';
    combustiveisList: any[] = [];
    locaisList: any[] = [];
    bombasList: any = [];

    form: FormGroup;
    ativo = new FormControl('');
    data = new FormControl('', Validators.required);
    quantidade = new FormControl('', Validators.compose([Validators.required, NumberValidator.numberFormat]));
    precoPorLitro = new FormControl('', Validators.required);
    precoTotal = new FormControl({value: '', disabled: true}, Validators.required);
    tipoLancamento = new FormControl('');
    notaFiscal = new FormControl('', Validators.required);
    documento = new FormControl('');
    empenho = new FormControl('');
    bemText = new FormControl({value: '', disabled: true});
    combustivelText = new FormControl({value: '', disabled: true});
    bem = new FormControl('', Validators.required);
    bomba = new FormControl('', Validators.required);
    combustivel = new FormControl({value: '', disabled: true}, Validators.required);
    area = new FormControl('', Validators.required);
    motorista = new FormControl('', Validators.required);
    local = new FormControl('', Validators.required);
    ajuste = new FormControl('');

    private combustiveisListClone: any[] = [];
    private locaisListClone: any[] = [];
    private bombasListClone: any[] = [];
    private tanquesList: any[] = [];
    private isEdition: boolean = false;
    private formObjectClone: any;
    private firstPrice: boolean = false;
    private precoCombustiveisLocalInterno: any[] = [];
    showTipoOdometro: boolean = true;

    constructor(
        private _route: ActivatedRoute,
        private _frotaService: FrotasService,
        private _frotaApiService: FrotaApiService,
        private _abastecimentoBemService: AbastecimentoBemService,
        private _abastecimentoBemApiService: AbastecimentoBemApiService,
        private _abastecimentoBemNavigationService: AbastecimentoBemNavigationService,
        private _areaApiService: AreaApiService,
        private _combustivelApiService: CombustivelApiService,
        private _bemCombustivelApiService: BemCombustivelApiService,
        private _motoristaApiService: MotoristaApiService,
        private _motoristaService: MotoristaService,
        private _localApiService: LocalApiService,
        private _localService: LocalService,
        private _tanqueApiService: TanqueApiService,
        private _bombaApiService: BombaApiService,
        private _frotaNavigationService: FrotaNavigationService,
        private _autocompleteService: AutoCompleteService,
        private _formaControleService: FormaControleService,

        private _utilService: UtilService,
        private _fb: FormBuilder,
        private _cdRef:ChangeDetectorRef
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            data: this.data,
            quantidade: this.quantidade,
            precoPorLitro: this.precoPorLitro,
            precoTotal: this.precoTotal,
            tipoLancamento: this.tipoLancamento,
            notaFiscal: this.notaFiscal,
            documento: this.documento,
            empenho: this.empenho,
            bemText: this.bemText,
            combustivelText: this.combustivelText,
            bem: this.bem,
            bomba: this.bomba,
            combustivel: this.combustivel,
            area: this.area,
            motorista: this.motorista,
            local: this.local,
            ajuste: this.ajuste
        })
    }

    ngOnInit() {
        this.frotaQuery = this._utilService.cloneObject(frotasQueryComCombustivel);
        this.motoristaQuery = this._utilService.cloneObject(motoristasQuery);
        this.areaQuery = this._utilService.cloneObject(areasQuery);

        let tipo: any = this._abastecimentoBemService.getTipoExterno();
        this.tipoAbastecimentoExterno = tipo.Key;
        tipo = this._abastecimentoBemService.getTipoInterno();
        this.tipoAbastecimentoInterno = tipo.Key;
        tipo = this._abastecimentoBemService.getTipoConvenio();
        this.tipoAbastecimentoConvenio = tipo.Key;

        this._utilService.disabledFutureDates('data');

        this.getCombustiveis();
        this.getLocais();
        this.testNew();
        this.testFrotaBackHistory();
    }

    ngAfterViewChecked() {
        this._cdRef.detectChanges();
    }

    clickGoToList() {
        this.toGetOutOfHere();
    }

    clickCancel() {
        this.toGetOutOfHere();
    }

    clickGoToFrotaDetail() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
    }

    clickGoToFrotaList() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToList(this.frotaRoute);
    }

    keyupQuantidade() {
        this.calculate();
    }

    keyupCurrency() {
        this.setPriceByLiter(this.formObject.precoPorLitro);
    }

    changeLocal() {
        if (this.localObject) {
            if (this.localObject.tipo) {
                this.setTipoLancamento();
            }
        }
    }

    changeBomba() {
        if (this.bombaObject) {
            if (this.bombaObject.tanque) {
                if (this.firstPrice) {
                    this.firstPrice = false;
                } else {
                    this.precoCombustivelLocalInterno();
                }

                if (this.bombaObject.tanque.combustivel) {
                    this.combustivelTextValue = this.bombaObject.tanque.combustivel.combustivel;
                }
            }
        }

        if (this.formObject.precoPorLitro) {
            this.setPriceByLiter(this.formObject.precoPorLitro);
        }
    }

    changeCombustivel() {
        if (this.firstPrice) {
            this.firstPrice = false;
            this.setPriceByLiter(this.formObjectClone.precoPorLitro);
            return false;
        }

        if (this.combustivelObject) {
            if (this.combustivelObject.preco) {
                this.setPriceByLiter(this.combustivelObject.preco);
            }
        }
    }

    changeAjuste() {
        if (this.formObject.ajuste) {
            this.showOnlyLocalInterno();
        } else {
            this.locaisList = this._utilService.cloneObject(this.locaisListClone);
            this.setFirstLocal();
        }
    }

    getFrotaObject(object: any) {
        this.frotaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'bem', object);
        this.frotaCombustiveis = object.Combustiveis;

        this.setCombustiveisBemText();

        this.setTipoLancamento();
        this.changeFormaControle();
    }

    frotaTemplateResult = (function(state: any) {
        return this._frotaService.templateResult(state, false);
    }.bind(this));

    getMotoristaObject(object: any) {
        this.motoristaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'motorista', object);
    }

    motoristaTemplateResult = (function(state: any) {
        return this._motoristaService.templateResult(state, false);
    }.bind(this));

    getAreaObject(object: any) {
        this.areaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'area', object);
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
            this._utilService.setSelectOnFormControl(this.form, 'bomba', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', "x");
        } else if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio) {
            this._utilService.setSelectOnFormControl(this.form, 'bomba', {id: -1});
        } else if (this.formObject.tipoLancamento === this.tipoAbastecimentoInterno) {
            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', "x");
        }

        if (this.formObject.ajuste) {
            this._utilService.setSelectOnFormControl(this.form, 'precoPorLitro', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'precoTotal', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'bem', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'motorista', {id: -1});
            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', "x");
        }


        let date: any = document.getElementById('data');
        if (date.value) {
            this._utilService.setSelectOnFormControl(this.form, 'data', date, 'value');
        }

        if (!this.formObject.odometroHorimetroValue) {
            return false;
        }

        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object: any = this._utilService.cloneObject(this.formObject);

            if (this.formObject.ajuste) {
                delete object['precoTotal'];
                delete object['odometroHorimetro'];
                delete object['precoPorLitro'];
            } else {
                if (this.frotaObject && this.frotaObject.id) {
                    object.bemId = this.frotaObject.id;

                    object.odometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.odometroHorimetroValue);
                    delete object['odometroHorimetroValue'];
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (this.motoristaObject && this.motoristaObject.id) {
                    object.motoristaId = this.motoristaObject.id;
                } else {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (object.quantidade == 0 || object.precoPorLitro == 0 || object.precoTotal == 0) {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (object.precoPorLitro) {
                    object.precoPorLitro = this._utilService.getCurrency(object.precoPorLitro);
                }

                if (object.precoTotal) {
                    object.precoTotal = this._utilService.getCurrency(object.precoTotal);
                }
            }

            if (this.areaObject && this.areaObject.id) {
                object.areaId = this.areaObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (object.quantidade == 0) {
                this.btnSaveDisabled = false;
                return false;
            }

            if (date.value) {
                object.data = this._utilService.convertStringToDate(date.value);
            }

            if (this.formObject.tipoLancamento === this.tipoAbastecimentoInterno || this.formObject.ajuste) {
                if (this.bombaObject && this.bombaObject.id) {
                    object.bombaId = this.bombaObject.id;

                    if (this.bombaObject.tanque) {
                        object.combustivelId = this.bombaObject.tanque.combustivelId;
                    }
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (this.localObject && this.localObject.id) {
                    object.localId = this.localObject.id;
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                delete object['notaFiscal'];
                delete object['documento'];
                delete object['empenho'];
            } else if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
                if (this.combustivelObject && this.combustivelObject.id) {
                    object.combustivelId = this.combustivelObject.id;
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                delete object['localId'];
                delete object['bombaId'];
                delete object['empenho'];
            } else if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio) {
                if (this.localObject && this.localObject.id) {
                    object.localId = this.localObject.id;
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }

                if (this.combustivelObject && this.combustivelObject.id) {
                    object.combustivelId = this.combustivelObject.id;
                } else  {
                    this.btnSaveDisabled = false;
                    return false;
                }
            }

            delete object['combustivel'];
            delete object['local'];
            delete object['bomba'];
            if (this.formObject.id) {
                this.onEdit(object);
            } else {
                this.onAdd(object);
            }
        }
    }

    private onAdd(object: AbastecimentoBem) {
        this._abastecimentoBemApiService.onPost(object, this.onDone);
    }

    private onEdit(object: AbastecimentoBem) {
        this._abastecimentoBemApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toGetOutOfHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private testNew() {
        let id: number = +this._route.snapshot.params['id'];
        if (id) {
            this.setEditNormal(id);
        } else {
            this.setNewNormal();
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setModelToForm() {
        if (this.formObject.bem) {
            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
            this.frotaObject.Combustiveis = this.frotaCombustiveis;
            delete this.formObject['bem'];

            let placa: string = '';
            if (this.frotaObject.placa) {
                placa = this.frotaObject.placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
                placa = placa + ' / ';
            }

            let selectObject:any = {text: placa.concat(this.frotaObject.identificacao), id: this.frotaObject.id};

            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'bem', this.frotaObject);
            this.changeFormaControle();
        }

        if (this.formObject.area) {
            this.areaObject = this.formObject.area;
            delete this.formObject['area'];

            let text = this._autocompleteService.getTextSelect2(this.areaObject, 'nome');
            let selectObject:any = {text: text, id: this.areaObject.id};

            this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.areaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
        }

        if (this.formObject.motorista) {
            this.motoristaObject = this._utilService.cloneObject(this.formObject.motorista);
            delete this.formObject['motorista'];

            if (this.motoristaObject.funcionario && this.motoristaObject.funcionario.pessoa) {
                let funcionario: any = this.motoristaObject.funcionario;
                let selectObject: any = {text: funcionario.pessoa.nome, id: this.motoristaObject.id};

                this._autocompleteService.createOptionOnSelect2(this.motoristaSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.motoristaSelectId);
                this._utilService.setSelectOnFormControl(this.form, 'motorista', this.motoristaObject);
            }
        }

        if (this.formObject.data) {
            this.formObject.data = this._utilService.convertDateToString(this.formObject.data);
        }

        if (this.formObject.odometroHorimetro) {
            this.formObject.odometroHorimetroValue = this._formaControleService.setOdometroHorimetroToForm(this.formObject.odometroHorimetro.odometroHorimetro);
            delete this.formObject['odometroHorimetro'];
        }

        if (this.formObject.local) {
            let local = this._utilService.cloneObject(this.formObject.local);
            delete this.formObject['local'];

            local.tipo = this.setLocalTipo(local.tipo);
            this.setFirstLocal(local);
        }

        if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
            this.localObject = this.locaisList[0];
        }
    }

    private setEditNormal(id: number) {
        this.isEdition = true;
        this.getObject(id);
    }

    private setNewNormal() {
        this.formObject.data = this._utilService.convertDateToString(new Date());
    }

    private calculate() {
        let total: any = 0;
        if (this.formObject.quantidade && this.formObject.precoPorLitro) {
            let price: any = this._utilService.cloneObject(this.formObject.precoPorLitro);
            if (price) {
                if(isNumeric(price)) {
                    price = price.toString();
                } else {
                    price = price.replace(/\./g, "");
                    price = price.replace(",", ".");
                }
            }
            price = parseFloat(price);

            if (!price) price = 0;
            total = this.formObject.quantidade * price;
            total = total.toFixed(2);
        }

        this.formObject.precoTotal = this._utilService.currencyFormat(total, false);
    }

    private getObject(id: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.formObjectClone = this._utilService.cloneObject(Response);
                this.getCombustiveisBem(Response.bemId);
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum abastecimento encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._abastecimentoBemApiService.onGetById(id, onDone);
    }

    private getCombustiveis() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Combustivel[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.combustiveisListClone = list;
                this.loadingSpinnerCombustiveis = false;
            }
        }.bind(this));

        this.loadingSpinnerCombustiveis = true;
        this._combustivelApiService.onGetAll(onDone);
    }

    private getCombustiveisLocal(localId: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: LocalCombustivel[] = [],
                    x = 0, lenX = Response.length,
                    item: any;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        item = Response[x].combustivel;
                        item.preco = Response[x].preco;
                        item.localId = Response[x].localId;
                        list.push(item);
                    }
                }

                this.combustiveisList = list;
                this.testBemCombustiveis();

                this.loadingSpinnerCombustiveis = false;
            }
        }.bind(this));

        this.loadingSpinnerCombustiveis = true;
        this._localApiService.onGetLocalCombustivelByLocal(localId, onDone);
    }

    private getCombustiveisLocalInterno(localId: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: LocalCombustivel[] = [],
                    x = 0, lenX = Response.length,
                    item: any;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        item = Response[x].combustivel;
                        item.preco = Response[x].preco;
                        item.localId = Response[x].localId;
                        list.push(item);
                    }
                }

                this.precoCombustiveisLocalInterno = list;
            }
        }.bind(this));

        this._localApiService.onGetLocalCombustivelByLocal(localId, onDone);
    }

    private getCombustiveisBem(bemId: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: any, lenX: any;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    Response[x] = Response[x].combustivel;
                }
                this.frotaCombustiveis = Response;
                this.setCombustiveisBemText();

                this.firstPrice = true;
                this.setModelToForm();
            }
        }.bind(this));

        this._bemCombustivelApiService.onGetByBem(bemId, onDone);
    }

    private getTanques(localId: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Tanque[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.tanquesList = list;
                if (this.bombasListClone.length) {
                    this.setBombas();
                } else {
                    this.getBombas();
                }
            }
        }.bind(this));

        this.loadingSpinnerBombas = true;
        this._tanqueApiService.onGetByLocal(localId, onDone);
    }

    private getBombas() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: Bomba[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.bombasListClone = list;
                this.setBombas();
            }
        }.bind(this));

        this._bombaApiService.onGetAll(onDone);
    }

    private getLocais() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: any[] = [],
                    x = 0, lenX = Response.length;

                for (x, lenX; x < lenX; x++) {
                    if (Response[x].ativo) {
                        Response[x].tipo = this.setLocalTipo(Response[x].tipo);
                        list.push(Response[x]);
                    }
                }

                list.unshift({
                    id: 0,
                    nome: "Abastecimento externo",
                    tipo: {Key: this.tipoAbastecimentoExterno}
                });

                this.locaisList = list;
                this.locaisListClone = this._utilService.cloneObject(list);
                this.loadingSpinnerLocais = false;

                this.setFirstLocal();
            }
        }.bind(this));

        this.loadingSpinnerLocais = true;
        this._localApiService.onGetAll(onDone);
    }

    private setLocalTipo(tipo: number) {
        let newTipo: any;
        const tipoLocalInterno: any = this._localService.getTipoInterno();
        const tipoLocalConvenio: any = this._localService.getTipoConvenio();

        if (tipo === tipoLocalInterno.Key) {
            newTipo = tipoLocalInterno;
            //coloca o numero do convenio conforme a lista de abastecimento bens
            newTipo.Key = this.tipoAbastecimentoInterno;
        } else {
            newTipo = tipoLocalConvenio;
            //coloca o numero do interno conforme a lista de abastecimento bens
            newTipo.Key = this.tipoAbastecimentoConvenio;
        }

        return newTipo;
    }

    private setBombas() {
        let x: number, lenX: number, y: number, lenY: number,
            list: any[] = [];

        for (x = 0, lenX = this.tanquesList.length; x < lenX; x++) {
            for (y = 0, lenY = this.bombasListClone.length; y < lenY; y++) {
                if (this.tanquesList[x].id === this.bombasListClone[y].tanqueId) {
                    list.push(this.bombasListClone[y]);
                }
            }
        }

        this.bombasList = list;
        if (this.formObject.ajuste) {
            this.setFisrtBomba();
        } else {
            this.testBemCombustiveis();
        }

        this.combustivelTextValue = '';
        this.loadingSpinnerBombas = false;
    }

    private setTipoLancamento() {
        this.formObject.tipoLancamento = this.localObject.tipo.Key;

        if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
            this.disabledCombustivel();
            setTimeout(function() {
                this.combustiveisList = this._utilService.cloneObject(this.combustiveisListClone);
                this.testBemCombustiveis();
            }.bind(this));

        } else if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio) {
            this.disabledCombustivel();
            this.getCombustiveisLocal(this.localObject.id);
        } else if (this.formObject.tipoLancamento === this.tipoAbastecimentoInterno) {
            this.disabledBomba();
            this.getTanques(this.localObject.id);
            this.getCombustiveisLocalInterno(this.localObject.id);
        }
    }

    private enabledCombustivel() {
        if (this.combustiveisList.length) {
            let element: any = this.form.controls['combustivel'];
            element.enable();
        }
    }

    private disabledCombustivel() {
        let element: any = this.form.controls['combustivel'];
        element.disable();
    }

    private enabledBomba() {
        if (this.bombasList.length) {
            let element: any = this.form.controls['bomba'];
            element.enable();
        }
    }

    private disabledBomba() {
        let element: any = this.form.controls['bomba'];
        element.disable();
    }

    private setPriceByLiter(newPrice: any) {
        let price = this._utilService.currencyFormat(newPrice, false);
        if (price) {
            this.formObject.precoPorLitro = price;
            this.calculate();
        }
    }

    private toGetOutOfHere() {
        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaAbastecimento(this.frotaRoute);
        } else {
            this._abastecimentoBemNavigationService.goToList();
        }
    }

    private testBemCombustiveis() {
        if (this.frotaObject.Combustiveis) {
            if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio ||
                this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {

                if (this.combustiveisList.length) {
                    this.combustiveisList = this.compareBemAndLocaisCombustiveis(this.combustiveisList, 'id');
                } else {
                    this.combustiveisList = [];
                }

                this.setFirstCombustivel();
            } else if(this.formObject.tipoLancamento === this.tipoAbastecimentoInterno) {
                if (this.bombasList.length) {
                    this.bombasList = this.compareBemAndLocaisCombustiveis(this.bombasList, 'combustivelId');
                } else {
                    this.bombasList = [];
                }

                this.setFisrtBomba();
            }
        }
    }

    private compareBemAndLocaisCombustiveis(fuelList: any, value: string) {
        let x: number, lenX: number, y: number, lenY: number,
            frotaFuel: any = this.frotaObject.Combustiveis,
            list: any[] = [];

        for (x = 0, lenX = frotaFuel.length; x < lenX; x++) {
            for (y = 0, lenY = fuelList.length; y < lenY; y++) {
                if (frotaFuel[x].id === fuelList[y][value]) {
                    list.push(fuelList[y]);
                }
            }
        }

        return list;
    }

    private setFirstCombustivel() {
        if (this.isEdition) {
            if (this.formObjectClone) {
                let x: number, lenX: number;
                for (x = 0, lenX = this.combustiveisList.length; x < lenX; x++) {
                    if (this.combustiveisList[x].id === this.formObjectClone.combustivelId) {
                        this.combustivelObject = this.combustiveisList[x];
                        break;
                    }
                }
            }
        } else {
            this.combustivelObject = this.combustiveisList[0];
        }

        if (this.combustiveisList.length) {
            this.enabledCombustivel();
        } else {
            this.disabledCombustivel();
        }
    }

    private setFisrtBomba() {
        if (this.isEdition) {
            if (this.formObjectClone) {
                let x: number, lenX: number;
                for (x = 0, lenX = this.bombasList.length; x < lenX; x++) {
                    if (this.bombasList[x].id === this.formObjectClone.bombaId) {
                        this.bombaObject = this.bombasList[x];
                        break;
                    }
                }
            }
        } else {
            this.bombaObject = this.bombasList[0];
        }

        if (this.bombasList.length) {
            this.enabledBomba();
        } else {
            this.disabledBomba();
        }
    }

    private setFirstLocal(object?: any) {
        if (this.isEdition) {
            if (object) {
                let x: number, lenX: number;
                for (x = 0, lenX = this.locaisList.length; x < lenX; x++) {
                    if (this.locaisList[x].id === object.id) {
                        this.localObject = this.locaisList[x];
                        break;
                    }
                }
            }
        } else {
            this.localObject = this.locaisList[0];
        }
    }

    private setCombustiveisBemText() {
        let vv: string[] = [];
        if (this.frotaCombustiveis) {
            this.frotaCombustiveis.forEach(function(item: Combustivel) {
                vv.push(item.combustivel);
            });
        }

        this.combustiveisBemText = vv.toString();
    }

    private showOnlyLocalInterno () {
        let tipoInterno: any = this._localService.getTipoInterno(),
            x: number, lenX: number,
            list: any[] = [];

        for (x = 0, lenX = this.locaisList.length; x < lenX; x++) {
            if (this.locaisList[x].tipo.Key === tipoInterno.Key) {
                list.push(this.locaisList[x]);
            }
        }

        this.locaisList = list;
        this.setFirstLocal();
    }

    private precoCombustivelLocalInterno() {
        let x: number, lenX: number, found: boolean = false;
        for (x = 0, lenX = this.precoCombustiveisLocalInterno.length; x < lenX; x++) {
            if (this.precoCombustiveisLocalInterno[x].id === this.bombaObject.tanque.combustivelId) {
                this.formObject.precoPorLitro = this.precoCombustiveisLocalInterno[x].preco;

                found = true;
                break;
            }
        }

        if (!found) {
            this.formObject.precoPorLitro = '';
        }
    }

    private changeFormaControle() {
        this.showTipoOdometro = this._formaControleService.changeFormaControle(this.frotaObject.formaControleId);
    }

    private testFrotaBackHistory() {
        const settings: any = this._frotaService.testBackHistory();

        this.frotaDetailHistory = settings.frotaDetailHistory;
        this.frotasModule = settings.frotasModule;
        this.frotaRoute = settings.frotaRoute;
        this.showFrotaLink = settings.showFrotaLink;

        // if (this.frotaRoute) {
        //     // if (this.actionTitle === newRoute) {
        //     //     let placa: string = '';
        //     //     if (history.placa) {
        //     //         placa = history.placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
        //     //         placa = placa + ' / ';
        //     //     }
        //     //
        //     //     let selectObject: any = {text: placa.concat(history.identificacao), id: history.id};
        //     //
        //     //     setTimeout(function() {
        //     //         this._autocompleteService.createOptionOnSelect2('frotaSelect', selectObject);
        //     //         this._autocompleteService.setValueOnSelect2(selectObject.id, 'frotaSelect');
        //     //         this.getFrotaObject(history);
        //     //     }.bind(this));
        //     // }
        //     this.showFrotaLink = true;
        // } else {
        //     this._frotaService.clearBackStorage();
        // }
    }
}


/*
 Abastecimento Externo
 - nota fiscal
 - documento

 Abastecimento Convenio
 - Local
 - nota fiscal
 - documento
 - empenho

 Abastecimento Interno
 - Local
 - Bomba

 */


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/abastecimento-bem-form/abastecimento-bem-form.component.ts
 **/